import { render, staticRenderFns } from "./CosmetologyImgs.vue?vue&type=template&id=3b0c77cd&"
import script from "./CosmetologyImgs.vue?vue&type=script&lang=js&"
export * from "./CosmetologyImgs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports